export default "__VITE_ASSET__fa238df3__"